export default __webpack_public_path__ + "static/media/other1.c46c63d9.jpg";